import { hasScopedPermission, GrantsType } from '../../Shared/utils/auth';

export const updateAgencyCompliancePolicy = (
  grants: GrantsType,
  ctx: {
    ancestorIds: Array<string>;
  }
) => {
  if (hasScopedPermission(grants, 'system', 'licensed_agencies.update')) {
    return true;
  }

  return (
    hasScopedPermission(grants, 'partner', 'licensed_agencies.update') &&
    grants.some((grant) => {
      return (
        grant.scope === 'partner' &&
        grant.scopeId &&
        ctx.ancestorIds.includes(grant.scopeId)
      );
    })
  );
};
